<template>
  <div></div>
</template>

<script>
export default {
  name: "ExternalPage",
  beforeMount() {
    if (this.$route.query.target !== '_blank') {
      window.location.replace(this.$route.query.url)
      return;
    }

    window.open(this.$route.query.url, this.$route.query.target);
    this.$router.go(-1);
  }
}
</script>

<style scoped>

</style>
